import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

import CommonRoutes from './Routes/CommonRoutes';

import { Web3ModalProvider } from './WagmiProvider/Web3ModalProvider';
import { WalletContextProvider } from './context/wallet.context';
import UserContextProvider from './context/user.context';
import HttpProvider from './context/http.provider';
import StakingContextProvider from './Pages/Vaults/contexts/staking.context';

const App = () => {
  return (
    <Web3ModalProvider>
      <HttpProvider>
        <UserContextProvider>
          <WalletContextProvider>
            <StakingContextProvider>
              <div className="App">
                <CommonRoutes />

                <ToastContainer
                  position="bottom-right"
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                  toastStyle={{
                    fontFamily: 'PoppinsMedium',
                    fontSize: '13px',
                    textAlign: 'left',
                    color: '#FFF',
                    background:
                      'linear-gradient(66deg, #BF0F67 0%, #0A0D6B 77%)',
                  }}
                />
              </div>
            </StakingContextProvider>
          </WalletContextProvider>
        </UserContextProvider>
      </HttpProvider>
    </Web3ModalProvider>
  );
};

export default App;
